import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  content: {
    marginBottom: '66px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  pageTitle: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '133%',
    letterSpacing: '0px',
  },
  description: {
    lineHeight: '29px',
    paddingTop: theme.spacing(2),
  },
  imageList: {
    margin: 0,
    gap: '24px !important',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr)) !important', // ~3 per row on large screens
    [theme.breakpoints.down('md')]: {
      gap: '24px !important',
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr)) !important', // ~3 per row on medium screens
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr)) !important', // ~3 per row on small screens
      gap: '16px !important',
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
  },
  chipContainer: {
    display: 'flex',
    gap: '8px',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  chip: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid var(--border)',
    backgroundColor: 'var(--background)',
    color: 'var(--foreground)',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  selectedChip: {
    backgroundColor: 'var(--foreground) !important',
    color: 'var(--background) !important',
    '&:hover': {
      backgroundColor: 'var(--foreground) !important',
      color: 'var(--background) !important',
    },
  },
  errorFetchLayout: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorPaper: {
    textAlign: 'center',
    padding: '150px 10px 40px',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  errorTitle: {
    margin: '24px auto 0',
    fontSize: '24px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  errorMessage: {
    margin: '50px auto 0',
    maxWidth: 400,
  },
  errorButtonWrapper: {
    marginTop: '50px',
  },
  errorButton: {
    textTransform: 'none',
  },
}));

export { useStyles };
